import { joinTruthyBy } from '@is24at/react-utils';
import { COMMA_SPACE } from '@is24at/react-constants';
import { companyName, zipCityString, streetString } from 'core/transformers';
import companyType from './companyType';

const description = (expose: any) => {
  const fullAddressString = joinTruthyBy(
    [zipCityString(expose), streetString(expose)],
    COMMA_SPACE,
  );
  const commonDescription = `${companyName(expose)} - Ihr ${companyType(
    expose.cwid,
  )} in ${fullAddressString}`;
  return `${commonDescription}. Jetzt ${companyName(
    expose,
  )} Immobilien finden bei ImmoScout24`;
};

export default description;
